import { serviceFields, lockCodeOfSystemRow } from './DictionaryFields'

import type { IFieldConfig } from '@/Core/Contracts/UI/Form'

/**
 * Поля сім'ї `StatusList` — шість довідників статусів (`SPEC-007` §5.1, §7.5).
 *
 * Порядок — як у легасі (`ListBaseStatusField.js`): Код, Назва, Сортування,
 * Колір. Колір у таблиці — квадрат-зразок ядра (`type: 'color'`); у реєстрах
 * CRM той самий колір малює Ship `StatusTag`.
 */
export const statusListFields = (): Record<string, IFieldConfig> => ({
    code: {
        label: 'Код',
        type: 'string',
        isRequired: true,
        depFn: lockCodeOfSystemRow,
    },
    title: {
        label: 'Назва',
        type: 'string',
        isRequired: true,
    },
    sorting: {
        label: 'Сортування',
        type: 'number',
        defaultValue: 500,
    },
    color: {
        label: 'Колір',
        type: 'color',
        isRequired: true,
    },
    ...serviceFields(),
})

/** Колонки легасі: Код · Назва · Сортування · Колір (`SPEC-007` §7.4). */
export const STATUS_LIST_COLUMNS = ['code', 'title', 'sorting', 'color']

/** Фільтри легасі: Ід · Назва · Код. */
export const STATUS_LIST_FILTERS = ['id', 'title', 'code']
